export default "__VITE_ASSET__eYnHJQtD__"